import api_access from '../../../api/apiInstance';
import { FETCH_TOKEN} from '../../../utils/constants';

/**
 * Fetch token for the encompass instance
 */
export async function fetchTokenApi(authCode:string | null): Promise<any> {
  try {
    const response = await api_access.post(FETCH_TOKEN,{code: authCode},
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching token:', error);
    throw error;
  }
}
export async function fetchAndStoreAccessToken(): Promise<void> {
  const authCodeValue = localStorage.getItem("auth_code");
  if (authCodeValue) {
    try {
      const tokenResponse = await fetchTokenApi(authCodeValue);
      localStorage.setItem("access_token", tokenResponse.access_token);
    } catch (error) {
      console.error('Error fetching and storing access token:', error);
      throw error; // Optionally re-throw the error if needed
    }
  } else {
    console.warn('No auth code found in localStorage.');
  }
}
